'use es6';

import keyMirror from 'react-utils/keyMirror';
export const AvailableState = keyMirror({
  UNINITIALIZED: null,
  INITIALIZED: null
});